<div class="dialog-container addmasterproduct">
    <div class="dialog-title-block">
        <h2>{{formData ? "Update Product":"Add Region"}}</h2>
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <form #f="ngForm" name="form" novalidate> 
        <div class="dialog-content-block p-3">
            <div class="form-group">
                <h6 class="text-start text-dark">Name</h6>
                <input type="text" name="product_code" [(ngModel)]="nameTxt" value="">
                <div class="form-error-msg"></div>
            </div>
        </div>
        <!-- <div class="form-error-msg">
            <p *ngIf="serverErrorMessage !== ''">{{ serverErrorMessage }}</p>
        </div> -->
        <div class="dialog-footer">
            <button type="button" (click)="onClose()">Cancel</button>
            <button class="primary-btn addproduct" type="submit" (click)="onAdd()">{{ formData ? "Update" : "Add"}}</button>
        </div>
    </form>
</div>
